import { LoadingButton } from "@mui/lab";
import {
  Button,
  Chip,
  DialogActions,
  DialogContent,
  Stack,
  Typography,
} from "@mui/material";
import { useSnackbar } from "notistack";
import React, { useState } from "react";
import { useUpdateGoalsMutation } from "../../services/profileAPI";
import { CustomDialogTitle } from "../../ui";

export const PROFILE_GOALS_OPTIONS = [
  "build exec presence & personal brand",
  "negotiate an appraisal or a promotion",
  "become a better negotiator",
  "build a network that you can leverage",
  "pivot in your career",
  "start your own business",
  "become a better leader",
  "transition from an ic role to a leadership role",
  "returning to work after a sabbatical or maternity break",
  "crack your next job interview",
  "find your purpose",
  "balancing/ integrating work and personal life",
  "have a relaxed mind and focus better",
  "stick to goals or effective habit formations",
  "looking for investors, co-founders, advisors",
  "looking for mentors",
];

function EditGoals({ goals, onClose }: any) {
  const [chosenValues, setChosenValues] = useState<string[] | []>(
    goals.filter((eachGoal: string) => PROFILE_GOALS_OPTIONS.includes(eachGoal))
  );
  const [updateGoals, { isLoading: isUpdateGoalsLoading }] =
    useUpdateGoalsMutation();

  const { enqueueSnackbar } = useSnackbar();

  const onUpdateHandler = async () => {
    try {
      if (!chosenValues.length) {
        return enqueueSnackbar("please select atleast one goal", {
          variant: "error",
        });
      }
      await updateGoals(chosenValues).unwrap();
      enqueueSnackbar("updated your goals", {
        variant: "success",
      });
      onClose();
    } catch (error) {
      console.error(error);
      enqueueSnackbar("failed to update your goals", {
        variant: "error",
      });
    }
  };

  const onTagPress = (tag: string) => {
    if (chosenValues?.find((id) => id === tag)) {
      const newTags = chosenValues?.filter((id) => id !== tag);
      setChosenValues(newTags);
    } else {
      setChosenValues((prevValues) => [...prevValues, tag]);
    }
  };

  return (
    <>
      <CustomDialogTitle onClose={onClose}>
        <Typography>edit goals</Typography>
      </CustomDialogTitle>
      <DialogContent dividers>
        <Stack direction="row" flexWrap="wrap">
          {PROFILE_GOALS_OPTIONS.map((tag) => {
            return (
              <Chip
                key={tag}
                label={tag}
                size="small"
                variant={
                  chosenValues?.find((id) => id === tag) ? "filled" : "outlined"
                }
                color={
                  chosenValues?.find((id) => id === tag) === tag
                    ? "primary"
                    : "default"
                }
                sx={{
                  mr: 1,
                  mb: 2,
                  fontSize: 12,
                  pl: 1.5,
                  pr: 1.5,
                  paddingTop: 1.7,
                  paddingBottom: 1.7,
                }}
                onClick={() => onTagPress(tag)}
              />
            );
          })}
        </Stack>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="secondary">
          cancel
        </Button>
        <LoadingButton
          variant="text"
          type="submit"
          loading={isUpdateGoalsLoading}
          onClick={onUpdateHandler}
        >
          update
        </LoadingButton>
      </DialogActions>
    </>
  );
}

export default EditGoals;
